import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const generateExcel = (data: any[], fileName: string): void => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Sheet 1');

  const headers = Object.keys(data[0]);
  // Add headers
  worksheet.addRow(
    headers.map((key) => key.toUpperCase().replaceAll('_', ' '))
  );

  // Add data
  data.forEach((item) => {
    const row: any[] = [];
    headers.forEach((header) => {
      row.push(item[header]);
    });
    worksheet.addRow(row);
  });

  // Save the workbook to a blob
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, fileName);
  });
};
